import { type FC } from 'react'
import { useNavigate } from 'react-router'
import { Button } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { sendEvent } from '@egw/events'
import { Layout, PageHeader } from '../../../components'

export const RecoveryReviewPage: FC = () => {
  const { t } = useTranslation('features-auth')

  const navigate = useNavigate()

  return (
    <Layout>
      <PageHeader title={t('recovery.review.title')} />
      <div className="text-body">
        <p className="mb-2xs">{t('recovery.review.description')}</p>
        <p className="mb-xs">{t('recovery.review.list_intro')}</p>
        <ul className="list-disc ml-lg flex flex-col gap-2xs">
          <li>{t('recovery.review.list_item_1')}</li>
          <li>{t('recovery.review.list_item_2')}</li>
          <li>{t('recovery.review.list_item_3')}</li>
          <li>{t('recovery.review.list_item_4')}</li>
          <li>{t('recovery.review.list_item_5')}</li>
        </ul>
      </div>

      <div className="flex-1 md:hidden" />
      <div className="flex flex-col md:flex-row gap-3xs md:gap-xs md:mt-8 mb-6">
        <Button
          testId="recoveryReviewTryAgain"
          className="mt-2 w-full md:w-max"
          onClick={() => {
            sendEvent('user_passkeyRecoveryReviewTryAgain_click', {
              eventSource: 'egWealth',
              category: 'passkey-recovery',
              subCategory: 'intent',
            })
            void navigate(WEALTH_ROUTES.RECOVERY.path)
          }}
        >
          {t('recovery.review.try_again_btn')}
        </Button>
        <Button
          variant="secondary"
          testId="recoveryReviewSignIn"
          className="mt-2 w-full md:w-max"
          onClick={() => {
            sendEvent('user_passkeyRecoveryReviewSignIn_click', {
              eventSource: 'egWealth',
              category: 'passkey-recovery',
              subCategory: 'intent',
            })
            void navigate(WEALTH_ROUTES.SIGN_IN.path)
          }}
        >
          {t('recovery.review.sign_in_btn')}
        </Button>
      </div>
    </Layout>
  )
}
